import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import LeasingCarForm from 'desktop/components/SearchPanelV2/LeasingCarForm/LeasingCarForm';
import LeasingHeadForm from 'desktop/components/SearchPanelV2/LeasingHeadForm/LeasingHeadForm';
import withLeasingUIConditions from 'shared/hocs/withLeasingUIConditions';

import SearchFormBottom from './SearchFormBottom/SearchFormBottom';
import SearchFormHeader from './SearchFormHeader/SearchFormHeader';
import CarsPanel from './CarsPanel';
import MotoPanel from './MotoPanel';
import CommercialPanel from './CommercialPanel';
import DealersPanel from './DealersPanel';
import SparesPanel from './SparesPanel';

// import history from '../../../history';
import s from './SearchPanelV2.css';

class SearchPanelV2 extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formResults: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    transportType: PropTypes.shape().isRequired,
    handleClearForm: PropTypes.func.isRequired,
    getSearchUrl: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    age: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
      }),
    ).isRequired,
    expandable: PropTypes.bool,
    searchable: PropTypes.bool,
    count: PropTypes.number,
    withLocation: PropTypes.bool,
    isLoading: PropTypes.bool,
    cardTypes: PropTypes.string,
    setAge: PropTypes.func,
    //
    intl: intlShape.isRequired,
    //
    showLeasingPrepayd: PropTypes.bool.isRequired,
    // showSearchButtons: PropTypes.bool.isRequired,
    showSearchButtons: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
    showCityAndIsNew: PropTypes.bool.isRequired,
    isCollapsed: PropTypes.bool.isRequired,
    searchFormName: PropTypes.string,
  };
  static defaultProps = {
    expandable: true,
    searchable: true,
    withLocation: true,
    isLoading: false,
    count: 0,
    cardTypes: undefined,
    setAge: null,
    searchFormName: null,
  };

  state = {
    collapsed: true,
    type: 'all',
    region: 'all',
  };

  setAge = age => {
    this.props.selectedActions.set.isNew(age.id);
    // this.props.formState.isNew = age.id;
    // history.push(this.props.getSearchUrl(this.props.formState));
  };

  toggleCollapse = () => {
    this.setState(prevState => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    const {
      formState,
      handleClearForm,
      getSearchUrl,
      page,
      formData = {},
      formResults = {},
      formVocabulary,
      cardTypes,
      expandable,
      age,
      searchable,
      withLocation,
      isLoading,
      count,
      intl,
      //
      showCityAndIsNew,
      showLeasingPrepayd,
      showSearchButtons,
      isCollapsed,
      searchFormName,
    } = this.props;

    // const newCount = formResults['dealers-AJAX'] && formResults['dealers-AJAX'].count;
    const { collapsed, region, type } = this.state;
    const url = getSearchUrl(formState);
    const defaultCardType = intl.formatMessage(
      {
        id: 'объявления',
      },
      {
        count: count % 100 > 19 ? count % 10 : count % 100,
      },
    );

    const pageName = page.toLowerCase();

    // const leasingCarFormPages = ['search', 'home'];
    // const collapsedAvaliableFor = ['search', 'home', 'spares', 'moto-search', 'commercial'];

    // const ComponentsPanel = {
    //   dealers: DealersPanel,
    //   spares: SparesPanel,
    //   'moto-search': MotoPanel,
    //   commercial: CommercialPanel,
    // };

    // console.log('!!! > ', pageName);

    // const showLeasingHeader = leasingCarFormPages.includes(pageName);
    // let showFormHeader = !showLeasingHeader;
    // let isCollapsed = collapsedAvaliableFor.includes(pageName);
    // let showFormBotton = true;
    // let ComponentPanel = null;
    // console.log('!!! > ', showLeasingHeader);
    // if (showLeasingHeader) {
    //   const showShortCarForm = !formState.isNew && !!formState.prepaid;
    //   const showDetailedForm =
    //     formState.isNew || !!(formData.brandToChose && formData.brandToChose.id);

    //   if (showShortCarForm) ComponentPanel = LeasingCarForm;
    //   else if (showDetailedForm) {
    //     ComponentPanel = ComponentsPanel[pageName] || CarsPanel;
    //     showFormHeader = true;
    //   } else ComponentPanel = null;

    //   showFormBotton = showShortCarForm || showDetailedForm;
    //   isCollapsed = !showShortCarForm;
    // } else {
    //   ComponentPanel = ComponentsPanel[pageName] || CarsPanel;
    // }
    // console.log('!!! > ', formData.brandToChose, ComponentPanel);

    // showLeasingPrepayd,
    // showSearchButtons,
    // isCollapsed,
    // searchFormName,

    // const ComponentsPanel = {
    //   dealers: 'dealers',
    //   spares: 'spares',
    //   'moto-search': 'moto',
    //   commercial: 'commercial',
    //   'leasingCar';
    // };

    const ComponentsPanel = {
      dealers: DealersPanel,
      spares: SparesPanel,
      moto: MotoPanel,
      commercial: CommercialPanel,
      leasingCar: LeasingCarForm,
      car: CarsPanel,
    };

    const ComponentPanel = ComponentsPanel[searchFormName] || null;

    return (
      <div className={s.root}>
        {showLeasingPrepayd && <LeasingHeadForm />}

        {showCityAndIsNew &&
          <SearchFormHeader
            isNew={pageName === 'dealers' ? formState.hasNew : formState.isNew}
            withLocation={withLocation}
            locations={formVocabulary.locations}
            regionId={region}
            setAge={this.props.setAge || this.setAge}
            age={age}
          />}

        {ComponentPanel &&
          <ComponentPanel
            {...this.props}
            collapsed={collapsed}
            toggleCollapsed={this.toggleCollapse}
          />}

        {showSearchButtons &&
          <SearchFormBottom
            count={count}
            collapsed={collapsed}
            isCollapsed={isCollapsed}
            type={type}
            url={url}
            expandable={expandable}
            searchable={searchable}
            handleClick={this.toggleCollapse}
            handleClearForm={handleClearForm}
            cardTypes={cardTypes || defaultCardType}
            isLoading={isLoading}
          />}
      </div>
    );
  }
}
const mapStateToProps = ({ searchForm = {} }) => ({
  formResults: searchForm.results,
  count: searchForm.data.count,
});
export default withStyles(s)(
  connect(mapStateToProps)(injectIntl(withLeasingUIConditions(SearchPanelV2))),
);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/SearchPanelV2.js